import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CardSimple from 'screens/components/basic/CardSimple';
import RadioInput from 'screens/components/basic/RadioInput';

const componentName = "InventoryMovement";
let searchMethods = [
    {
        text: "Name",
        value: "name"
    },
    {
        text: "SKU",
        value: "sku"
    }]

const Header = ({ showBody, download, searchMethod }) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-12 col-md-6 col-lg-3 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-md-6 col-lg-3 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-md-6 col-lg-6 col-xl-6">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-md-6 col-lg-4 col-xl-4">
                <RadioInput
                    title="Search Method"
                    groupName={`productPOSearchMethod`}
                    options={searchMethods}
                    className="inline-radio-btns"
                    fullWidth={true}
                    required
                />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-6 col-xl-6">
                <AutoCompleteInput
                    methodName="productPOSearchMethod"
                    name={`${componentName}ProductId`}
                    floatingLabelText={searchMethod == "sku" ? "Search a product by SKU" : "Search a product by Name"}
                    hintText="Product"
                    className="AutoCompleteInput-searchbar w-100"
                 />
            </div> {/* .col */}
        </div>
        <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={download}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
